import useTranslation from "../../client/hooks/useTranslation";

export default function WhyEdgely({ points }: { points: string[] }) {
  const t = useTranslation();
  return (
    <section className="px-6 py-16 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <h2 className="font-display text-2xl font-bold tracking-tight text-foreground text-center sm:text-3xl">
          {t.marketing.common.whyTitle}
        </h2>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {points.map((p, i) => (
            <div key={i} className="rounded-2xl border border-border bg-card p-6">
              <span className="font-display text-3xl font-bold text-primary">{i + 1}</span>
              <p className="mt-3 text-base leading-7 text-foreground">{p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
